import React from 'react';
import classNames from 'classnames';

import Thumbnail from '../chat/chat-document-thumbnail';
import WaitingIndicator from '../general-components/waiting-indicator';
import HoverIcon from '../showboard/hover-icon';
import { COLORS, ICONS } from '../general-components/icon';
import ShowBuilderCardToggle from "./showbuilder-card-toggle";

interface ImageCardToggleProps {
	graphicId: number;
	title: string;
	subtitle: string | JSX.Element[];
	isOn: boolean;
	toggle: () => void;
	isChanging?: boolean;
	imgSrc?: string;
	customThumb?: JSX.Element;
	children?: React.ReactNode;
	onThumbnailClick?: Function;
	toggleHidden?: boolean;
	isDisabled?: boolean;
}

export default function ImageCardToggle({
	graphicId,
	title,
	subtitle,
	isOn,
	toggle,
	isChanging,
	imgSrc,
	customThumb,
	children,
	onThumbnailClick,
	toggleHidden = false,
	isDisabled = false,
}: ImageCardToggleProps) {
	const getThumbnail = () => (
			<div
				className={classNames('thumbnail-container', {
					'cursor-pointer': typeof onThumbnailClick !== 'undefined',
				})}
			>
				{customThumb || (
					<Thumbnail thumbnail={imgSrc} />
				)}
			</div>
	);

	return (
		<div className={classNames('image-card-toggle', {
			showing: isOn || toggleHidden,
		})}>
			{(imgSrc || customThumb) && (
				<div className="thumbnail">
					{!onThumbnailClick ? getThumbnail() : (
						<HoverIcon
							color={COLORS.WHITE}
							icon={ICONS.EDIT} onClick={() => onThumbnailClick()}
							size={16}
						>
							{getThumbnail()}
						</HoverIcon>
					)}
				</div>
			)}
			<div className="image-card-details">
				<div className="image-card-details-metadata">
					<p className="image-card-title truncate-overflow" title={title}>{title}</p>
					{!Array.isArray(subtitle) && (
						<p className="image-card-subtitle truncate-overflow" title={subtitle}>{subtitle}</p>
					)}
					{Array.isArray(subtitle) && subtitle.map((s, i) => (
							<p key={`index_${i}`} className="image-card-subtitle truncate-overflow">{s}</p>
					))}
				</div>
				{children && (
					<div className="image-card-children">
						{children}
					</div>
				)}
				{!toggleHidden ? (
					<button
						className={classNames(
							'button-toggle round',
							{ 'background-green': isOn },
							'slightly-bold',
							{ disabled: isDisabled },
							'no-select',
						)}
						onClick={toggle}
						data-testid={`graphic-toggle-btn-${graphicId}`}
					>
						{isChanging ? (
							<WaitingIndicator />
						) : (
							`Build ${isOn ? 'Out' : 'In'}`
						)}
					</button>
				) : (<></>)}
			</div>
			{toggleHidden && (
				<ShowBuilderCardToggle graphicId={graphicId} />
			)}
		</div>
	);
}
